import { WebRequest } from '@cgn/framework-ui-components/v1';

const getQuestito = (
  servizio,
  categoria,
  argomento,
  quesito,
  {
    profilo, idMessaggio, origine, ufficioSelezionato,
  },
) => ({
  NomeUtente: profilo && profilo.Nome,
  CognomeUtente: profilo && profilo.Cognome,
  IdCategoria: argomento ? argomento.IdCategoria : categoria.IdCategoria,
  CampoAux1: quesito.campoAux1,
  CampoAux2: quesito.campoAux2,
  IdServizio: servizio.IdServizio,
  Corpo: quesito.messaggio,
  IdUfficio: ufficioSelezionato,
  TitolareStudio: `${profilo && profilo.Nome} ${profilo && profilo.Cognome}`,
  Titolo: quesito.oggetto,
  IdentificativiAllegatiTemporanei: (quesito.allegati || []).map((file) => file.id),
  IdentificativoMessaggio: idMessaggio,
  Origine: origine,
});

// eslint-disable-next-line import/prefer-default-export
export function creaPratica(baseUrl, {
  servizio, categoria, argomento, oggetto, messaggio, allegati, campoAux1, campoAux2, profilo, idMessaggio, origine, ufficioSelezionato,
}) {
  return WebRequest.post(`${baseUrl}/NuovaPratica/Crea`, getQuestito(
    servizio,
    categoria,
    argomento,
    {
      oggetto, messaggio, allegati, campoAux1, campoAux2,
    },
    {
      profilo, idMessaggio, origine, ufficioSelezionato,
    },
  ));
}

export function loadCategoriePerServizio(baseUrl, idServizio) {
  return WebRequest.get(`${baseUrl}/NuovaPratica/Categorie`, { idServizio });
}

export function loadServizioPerUfficio(baseUrl, ufficioSelezionato) {
  return WebRequest.get(`${baseUrl}/NuovaPratica/Servizi`, { codiceUfficio: ufficioSelezionato });
}

export function loadTuttiServizioPerUfficio(baseUrl) {
  return WebRequest.get(`${baseUrl}/NuovaPratica/TuttiServizi`);
}
